import React from 'react';

import { Typography } from 'antd';
import classnames from 'classnames';

const { Text } = Typography;

const MinimumRequirementsText = ({
  text,
  className,
  isError,
  isWarning,
  ...restProps
}) => {
  return (
    <Text
      type={isWarning ? 'warning' : isError ? 'danger' : undefined}
      className={classnames({
        'minimum-requirement__text': true,
        [className]: !!className,
      })}
      {...restProps}
    >
      {text}
    </Text>
  );
};

export default MinimumRequirementsText;
